import { useContext } from 'react'
import { MembersContext } from '../context/MembersContext'

export const useMembersContext = () => {
  const context = useContext(MembersContext)
  if (!context) {
    throw new Error('useMembersContext must be used within MembersProvider')
  }
  return context
}
